var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-star-rating-wrapper"},[_c('star-rating',_vm._b({attrs:{"border-width":1,"read-only":true,"show-rating":false}},'star-rating',_vm.$props,false)),_vm._v(" "),_c('span',{attrs:{"aria-label":"rating"}},[_vm._v(_vm._s(_vm.totalRatingCountInBrackets))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }